





























import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { DataTableState, TableContext } from '@/typings/datatable';
import DataTableWithFilters, { DataTableFilter } from '@/components/datatable-filters.vue';

import { Sensor, SensorsApi } from '@/api';
import { ApiUtils, FilterParam } from '@/common/ApiUtils';
import RouterLinkButton from '@/components/elements/buttons/router-link-button.vue';

@Component({
	components: {
		RouterLinkButton,
		secondaryNav,
		DataTableWithFilters,
	},
})
export default class SensorsList extends Vue {
	public state: DataTableState = {
		fields: [
			{ key: 'id', sortable: true },
			{ key: 'uniqueId', sortable: true },
			{ key: 'serialNumber', sortable: true },
			{ key: 'type', label: 'Assignment', sortable: true },
			{ key: 'transceiver.serialNumber', label: 'Transceiver', sortable: false },
			{ key: 'transceiver.site.name', label: 'Site', sortable: false },
		],
		loading: false,
		search: null,
		sortBy: 'id',
		primaryKey: 'id',
		sortDesc: false,
		perPage: 20,
		currentPage: 1,
		totalRows: 0,
	};

	public filters: DataTableFilter[] = [
		{
			label: 'Sensor Assignment',
			field: 'type',
			value: [],
			type: 'checkboxes',
			options: [
				{ text: 'Unassigned', value: null },
				{ text: 'Vat Temp', value: 'vatTemp' },
				{ text: 'Inlet Temp', value: 'inlet' },
				{ text: 'Lidar Distance', value: 'lidarDistance' },
				{ text: 'Radar Distance', value: 'radarDistance' },
				{ text: 'Stirrer', value: 'stirrer' },
				{ text: 'Capacitance', value: 'capacitance' },
			],
		},
	];

	private api: SensorsApi;

	constructor() {
		super();
		this.api = new SensorsApi();
	}

	public reload() {
		this.$root.$emit('bv::refresh::table', 'sensors-datatable');
	}

	public clickTable(item: Sensor, newtab: boolean) {
		if (newtab) {
			const routeData = this.$router.resolve({
				name: 'sensors.view',
				params: { sensorId: item.id },
			} as any);
			window.open(routeData.href, '_blank');
		} else {
			this.$router.push({
				name: 'sensors.view',
				params: { sensorId: item.id },
			} as any);
		}
	}

	public async dataTableProvider(ctx: TableContext) {
		let data: any = [];

		try {
			const filters: FilterParam[] = this.filters.map((filter: DataTableFilter) => {
				return { field: filter.field, value: filter.value };
			});
			if (this.state.search) {
				// filters.push({field: 'serialNumber', value: this.state.search});
				this.state.search = this.state.search.replaceAll(' ', '-'); // Allowing spaces to be typed instead of dashes
				filters.push({ field: 'custom', value: this.state.search });
			}
			const response = await this.api.getSensors(
				ApiUtils.queryOptions(filters, ctx, {
					params: { include: 'transceiver,transceiver.site' },
				}),
			);
			data = response.data.data;
			this.state.totalRows = response.data.meta.total || 0;
		} catch (e) {
			this.state.totalRows = 0;

			console.log(e);
		}
		return data;
	}
}
